import { ContentBlock as ContentBlockType, FormConfig, FormValues } from '@topdanmark-onlinesolutions/claim-form-types';

const ContentBlock = ({ value }: ContentBlockType) => {
    return <div className="u-spacing-stack-m" dangerouslySetInnerHTML={{ __html: value }} />;
};

ContentBlock.isValid = (formConfig: FormConfig, formValues: FormValues, elementId: string): boolean => {
    return true;
};

export default ContentBlock;
